import React from 'react';
import { FindAllMyProjectsResponse } from '@ansvar-sakerhet/api-client';
import { useGetClientProjects } from '../../../../../../../../../../../traits/api/projects/useGetClientProjects';
import { Loading } from '../../../../../../../../../../../components/Loading';
import { S } from './ProjectAccessFields.styles';

type Props = {
  clientId: string;
  hasAllProjectAccess: boolean;
  selectedProjectIds: string[];
  onHasAllProjectAccessChange: (value: boolean) => void;
  onSelectedProjectIdsChange: (projectIds: string[]) => void;
};

export const ProjectAccessFields = ({
  clientId,
  hasAllProjectAccess,
  selectedProjectIds,
  onHasAllProjectAccessChange,
  onSelectedProjectIdsChange,
}: Props) => {
  const { data: projects, isLoading } = useGetClientProjects(clientId);

  const toggleProject = (projectId: string) => {
    if (selectedProjectIds.includes(projectId)) {
      onSelectedProjectIdsChange(
        selectedProjectIds.filter((id) => id !== projectId)
      );
      return;
    }
    onSelectedProjectIdsChange([...selectedProjectIds, projectId]);
  };

  return (
    <S.Container>
      <S.CheckboxRow>
        <input
          id="hasAllProjectAccess"
          type="checkbox"
          checked={hasAllProjectAccess}
          onChange={(e) => onHasAllProjectAccessChange(e.target.checked)}
        />
        <label htmlFor="hasAllProjectAccess">Tillgång till alla projekt</label>
      </S.CheckboxRow>

      {!hasAllProjectAccess && (
        <S.ProjectsSection>
          <S.Label>Välj projekt</S.Label>
          {isLoading || !projects ? (
            <Loading />
          ) : projects.length === 0 ? (
            <S.B3>Inga projekt att visa.</S.B3>
          ) : (
            <S.ProjectList>
              {projects.map((project: FindAllMyProjectsResponse) => (
                <S.CheckboxRow key={project.projectId}>
                  <input
                    id={`project-${project.projectId}`}
                    type="checkbox"
                    checked={selectedProjectIds.includes(project.projectId)}
                    onChange={() => toggleProject(project.projectId)}
                  />
                  <label htmlFor={`project-${project.projectId}`}>
                    {project.name}
                  </label>
                </S.CheckboxRow>
              ))}
            </S.ProjectList>
          )}
        </S.ProjectsSection>
      )}
    </S.Container>
  );
};
